import React from "react";

const translations = {
  tr: {
    sectionTitle: "İLETİŞİM BİLGİLERİ",
    sectionDesc: "Akay Conseil'in ofis adresine, iletişim numaralarına (telefon ve WhatsApp) ve e-posta adresine aşağıdaki bilgilerden ulaşabilirsiniz. Google Haritalar'dan ise doğrudan konumumuzu görüntüleyebilirsiniz.",
    address: "Adres",
    whatsapp: "WhatsApp",
    email: "E-posta",
    ourLocation: "Konumumuz",
    getDirections: "Yol Tarifi Al",
    loading: "Yükleniyor..."
  },
  en: {
    sectionTitle: "CONTACT INFORMATION",
    sectionDesc: "You can reach Akay Conseil's office address, contact numbers (phone and WhatsApp) and email address from the information below. You can also view our location directly from Google Maps.",
    address: "Address",
    whatsapp: "WhatsApp",
    email: "Email",
    ourLocation: "Our Location",
    getDirections: "Get Directions",
    loading: "Loading..."
  },
  fr: {
    sectionTitle: "INFORMATIONS DE CONTACT",
    sectionDesc: "Vous pouvez accéder à l'adresse du bureau d'Akay Conseil, aux numéros de contact (téléphone et WhatsApp) et à l'adresse e-mail à partir des informations ci-dessous. Vous pouvez également visualiser notre emplacement directement depuis Google Maps.",
    address: "Adresse",
    whatsapp: "WhatsApp",
    email: "E-mail",
    ourLocation: "Notre Emplacement",
    getDirections: "Obtenir l'Itinéraire",
    loading: "Chargement..."
  }
};

export const ContactInfo = (props) => {
  const currentLang = (props.lang || "tr").toLowerCase();
  const t = translations[currentLang] || translations.tr;

  const handleAddressClick = () => {
    const address = props.data ? props.data.address : '';
    if (address) {
      window.open(`https://www.google.com/maps/search/${encodeURIComponent(address)}`, '_blank');
    }
  };

  const handlePhoneClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const phone = props.data?.phone1 || props.data?.phone || '';

    if (phone) {
      let cleanPhone = phone.replace(/[^0-9]/g, '');

      if (cleanPhone.startsWith('0')) {
        cleanPhone = '90' + cleanPhone.substring(1);
      } else if (!cleanPhone.startsWith('90')) {
        cleanPhone = '90' + cleanPhone;
      }

      const whatsappUrl = `https://wa.me/${cleanPhone}`;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      if (isMobile) {
        window.location.href = whatsappUrl;
      } else {
        window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
      }
    }
  };

  const handleEmailClick = () => {
    const email = props.data ? props.data.email : '';
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  };

  const formatPhoneForDisplay = (phone) => {
    if (!phone) return t.loading;

    const cleaned = phone.replace(/[^0-9]/g, '');
    if (cleaned.length >= 10) {
      return (
        <span>
          <span>+90</span>
          <span> </span>
          <span>{cleaned.slice(-10, -7)}</span>
          <span> </span>
          <span>{cleaned.slice(-7, -4)}</span>
          <span> </span>
          <span>{cleaned.slice(-4, -2)}</span>
          <span> </span>
          <span>{cleaned.slice(-2)}</span>
        </span>
      );
    }
    return phone;
  };

  return (
    <div id="contactinfo" className="text-center">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 section-title">
            <h2>{t.sectionTitle}</h2>
            <p>{t.sectionDesc}</p>
          </div>
        </div>
        <div className="row">
          {/* Adres */}
          <div className="col-md-4 col-sm-6">
            <div className="contact-info-item" onClick={handleAddressClick} style={{ cursor: 'pointer' }}>
              <div className="contact-icon">
                <i className="fa fa-map-marker"></i>
              </div>
              <div className="contact-details">
                <h4>{t.address}</h4>
                <p>{props.data ? props.data.address : t.loading}</p>
              </div>
            </div>
          </div>

          {/* WhatsApp */}
          <div className="col-md-4 col-sm-6">
            <div className="contact-info-item" onClick={handlePhoneClick} style={{ cursor: 'pointer' }}>
              <div className="contact-icon">
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4575 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4575 4.15385 17C4.15385 19.5395 4.9084 21.8998 6.17572 23.8401L5.07692 27.6068L8.95382 26.5765C10.8452 27.7455 13.3414 28.8462 16 28.8462Z"
                    fill="white"
                  />
                  <path
                    d="M12.5 9.49989C12.1672 8.83131 11.6565 8.8905 11.1407 8.8905C10.2188 8.8905 8.78125 9.99478 8.78125 12.05C8.78125 13.7343 9.52345 15.578 12.0244 18.3361C14.438 20.9979 17.6094 22.3748 20.2422 22.3279C22.875 22.2811 23.4167 20.0154 23.4167 19.2503C23.4167 18.9112 23.2062 18.742 23.0613 18.696C22.1641 18.2654 20.5093 17.4631 20.1328 17.3124C19.7563 17.1617 19.5597 17.3656 19.4375 17.4765C19.0961 17.8018 18.4193 18.7608 18.1875 18.9765C17.9558 19.1922 17.6103 19.083 17.4665 19.0015C16.9374 18.7892 15.5029 18.1511 14.3595 17.0426C12.9453 15.6718 12.8623 15.2001 12.5959 14.7803C12.3828 14.4444 12.5392 14.2384 12.6172 14.1483C12.9219 13.7968 13.3426 13.254 13.5313 12.9843C13.7199 12.7145 13.5702 12.305 13.4803 12.05C13.0938 10.953 12.7663 10.0347 12.5 9.49989Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="contact-details">
                <h4>{t.whatsapp}</h4>
                <p className="phone-display">
                  {formatPhoneForDisplay(props.data?.phone || props.data?.phone2)}
                </p>
              </div>
            </div>
          </div>

          {/* E-posta */}
          <div className="col-md-4 col-sm-6">
            <div className="contact-info-item" onClick={handleEmailClick} style={{ cursor: 'pointer' }}>
              <div className="contact-icon">
                <i className="fa fa-envelope"></i>
              </div>
              <div className="contact-details">
                <h4>{t.email}</h4>
                <p>{props.data ? props.data.email : t.loading}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Google Haritalar */}
        <div className="row">
          <div className="col-md-12">
            <div className="google-maps-section">
              <h3>{t.ourLocation}</h3>
              <div className="map-container">
                <iframe
                  src={props.data ? props.data.googleMapsUrl : ""}
                  width="100%"
                  height="400"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Akay Conseil"
                ></iframe>
              </div>
              <div className="route-button-container">
                <button
                  onClick={() => {
                    const address = props.data ? props.data.address : '';
                    if (address) {
                      window.open(`https://www.google.com/maps/dir//${encodeURIComponent(address)}`, '_blank');
                    }
                  }}
                  className="route-button"
                >
                  <i className="fa fa-location-arrow"></i> {t.getDirections}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};